var React = require('react');

function Tooth (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M444 96.25c10.13 41.63.42 80.82-21.53 110.43-23.37 31.57-32.69 68.65-36.3 107.32-4.41 47.16-10.33 94.17-20.94 140.32l-7.8 33.95a30.42 30.42 0 0 1-59.21.54l-34.47-138.39a40.95 40.95 0 0 0-79.52 0l-34.47 138.42a30.42 30.42 0 0 1-59.21-.54l-7.8-33.95C72.14 408.19 66.21 361.19 61.81 314c-3.61-38.69-12.93-75.78-36.29-107.35C3.6 177.06-6.11 137.87 4 96.25 15 51 51.13 14.2 96 2.53c23.43-6.09 46.11-.54 66.81 10.31l100.54 64.62a16 16 0 0 0 17.31-26.91l-28.32-18.21c3.54-1.75 7.25-3.09 10.5-5.48C289 7.63 319.79-5.83 352 2.53c44.88 11.66 81 48.47 92 93.72z","className":"fa-secondary","key":1})]);
}

Tooth.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Tooth;

Tooth.default = Tooth;
